// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3AVnw","inputWrap":"styles_inputWrap__7K2Nk","input":"styles_input__3yrIu"};